import { qs } from "../utils/dom"
import { initAnimation } from "./fishAnimation"

export const initFishAnimation = () => {
  if (qs("#context-background")) initAnimation()
}
